document.addEventListener('click', (event) => {
  const target = event.target;

  if (
    target.classList.contains('smooth-scroll')
  ) {
    event.preventDefault();

    const containers = document.querySelectorAll('.color-multicolumn_width_image');
    const container = containers[1];

    if (container) {
      window.scrollTo({
        top: container.offsetTop - 120,
        behavior: 'smooth',
      });
    }
  }
});